import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'How quickly can you respond to an emergency?',
  answer: 'Our team is available 24/7 and we typically arrive within 1 hour for emergency calls in our service area.'
}, {
  question: 'Are you licensed and insured?',
  answer: 'Absolutely. We are fully licensed (License #319535), bonded, and carry comprehensive insurance for your peace of mind.'
}, {
  question: 'Do you provide upfront pricing?',
  answer: 'Yes. We always provide a clear, written estimate before any work begins. No surprises, no hidden fees.'
}, {
  question: 'Do you offer financing?',
  answer: 'Yes, we offer 0% APR financing options on qualifying jobs. Ask us about plans that fit your budget.'
}, {
  question: 'What areas do you serve?',
  answer: 'We proudly serve Henderson, Las Vegas, Green Valley, Summerlin, Boulder City, North Las Vegas, and surrounding communities.'
}, {
  question: 'Do you guarantee your work?',
  answer: 'Every job we complete is backed by our workmanship guarantee. If you are not satisfied, we will make it right.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-white" data-id="element-30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-navy uppercase mb-4" data-id="element-33">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600" data-id="element-34">
            Got questions? We've got answers to help you make an informed
            decision.
          </p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-35">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-md overflow-hidden transition-colors duration-300 ${isOpen ? 'border-brand-red/30 bg-brand-gray/50' : 'border-gray-200 bg-white'}`} data-id="element-36">
                <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-inset" aria-expanded={isOpen} data-id="element-37">
                  <span className={`font-bold uppercase tracking-wide pr-4 ${isOpen ? 'text-brand-red' : 'text-brand-navy'}`} data-id="element-38">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brand-red' : 'text-gray-400'}`} data-id="element-39" />
                </button>

                <AnimatePresence initial={false} data-id="element-40">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-41">
                      <div className="p-5 pt-0 text-gray-600 leading-relaxed border-t border-gray-100 mt-2" data-id="element-42">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-brand-gray p-6 rounded-md border border-gray-200" data-id="element-43">
          <p className="text-gray-700 font-medium" data-id="element-44">
            Still have questions? <br className="sm:hidden" data-id="element-45" />
            <a href="tel:7026425352" className="text-brand-red font-bold hover:underline ml-1" data-id="element-46">
              Call us at (702) 642-5352
            </a>
          </p>
        </div>
      </div>
    </section>;
}